import { Module } from '@nestjs/common';
import { QueuesModule } from 'src/queues/queues.module';
import { winstonConfig } from '../common/logger/winston.config';
import { EmpresasModule } from '../empresas/empresas.module';
import { SucursalesController } from './sucursales.controller';
import { SucursalesService } from './sucursales.service';

@Module({
  controllers: [SucursalesController],
  providers: [SucursalesService],
  imports: [EmpresasModule, QueuesModule],
  exports: [SucursalesService],
})
export class SucursalesModule {}
